import type { ListBoxProps } from 'react-aria-components';
import { ListBox as BaseListBox } from 'react-aria-components';

import classes from './ListBox.module.css';

type Props<T extends object> = ListBoxProps<T>;

export const ListBox = <T extends object>(props: Props<T>) => {
  return (
    <BaseListBox
      aria-label="Search suggestions"
      className={classes.root}
      selectionMode="single"
      {...props}
    />
  );
};
